module.exports = __webpack_public_path__ + "img/sex-for-aaben-6.a734c209.png";